<template>
  <el-card>
    <el-form label-position="left" label-width="auto" :model="formData" ref="form" :rules="rules">
      <el-form-item :label="$t('动态编号')">
        <el-input :placeholder="$t('动态编号')" disabled :value="formData.num"/>
      </el-form-item>

      <el-form-item :label="$t('动态内容')" prop="content">
        <el-input :placeholder="$t('动态内容')" v-model="formData.content" />
      </el-form-item>

      <el-form-item :label="$t('动态图片')">
        <pic-upload
            :limit="9"
            :download-url="$api.file.downloadImg"
            :action="$api.file.upload"
            v-model="formData.photo"/>
      </el-form-item>

      <el-form-item :label="$t('发布者编号')">
        <el-input :placeholder="$t('发布者编号')" disabled v-model="formData.userNum"/>
      </el-form-item>

      <el-form-item :label="$t('发布者昵称')">
        <el-input :placeholder="$t('发布者昵称')" disabled v-model="formData.username"/>
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <el-input :placeholder="$t('发布时间')" disabled :value="formData.createTimeStr" />
      </el-form-item>

      <el-form-item :label="$t('点赞数')">
        <el-input :placeholder="$t('点赞数')" v-model="formData.baseLike" />
      </el-form-item>

      <el-form-item :label="$t('讨论数')">
        <el-input :placeholder="$t('讨论数')" v-model="formData.commentCount" disabled />
      </el-form-item>

      <el-form-item :label="$t('精品置顶')">
        <el-input :placeholder="$t('精品置顶')" v-model="formData.topping"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit">{{ $t('保存') }}</el-button>
        <el-button @click="handleReset">{{ $t('重置') }}</el-button>
      </el-form-item>

    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import PicUpload from "@/components/pic-upload/PicUpload";
import {resetEmpty} from "@/utils/common";

export default {
  name: "DynamicEdit",
  components: {PicUpload},
  data() {
    return {
      formData: {
        code: "",
        num: "",
        content: "",
        userNum: "",
        username: "",
        baseLike: "",
        baseComment: "",
        topping: "",
        photo: "",
        topicCode: null,
      },
      rules: {
        content: {required: true, message: this.$t('请输入动态内容'), trigger: 'blur'}
      }
    }
  },
  methods: {
    // 提交
    async handleSubmit() {
      try {
        await request(this.$api.dynamics.update, this.formData);
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },

    handleReset() {
      resetEmpty(this.formData);
      this.$refs.form.resetFields();
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.dynamics.detail, this.$route.query);
        for (const key in this.formData) {
          this.formData[key] = res.dynamics[key];
        }
        this.formData.createTimeStr = this.$moment(res.dynamics.createTime).format("YYYY-MM-DD HH:mm:ss");
        this.formData.photo = res.dynamics.photo ? res.dynamics.photo : "";
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 700px;
}

</style>
